import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MapPin, Home, Heart, Calendar, Settings, MessageSquare } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface NavigationProps {
  user: any;
  userRole: string | null;
}

export const Navigation = ({ user, userRole }: NavigationProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const buttonVariant = isMobile ? "ghost" : "ghost";
  const buttonClassName = isMobile ? "w-full justify-start" : "flex items-center gap-2";

  if (!user) {
    return (
      <div className={isMobile ? "flex flex-col space-y-2" : "flex items-center space-x-4"}>
        <Button
          variant={buttonVariant}
          onClick={() => navigate("/properties")}
          className={buttonClassName}
        >
          <MapPin className="h-4 w-4" />
          Find Places
        </Button>
        <Button
          variant={buttonVariant}
          onClick={() => navigate("/host/onboarding")}
          className={buttonClassName}
        >
          <Home className="h-4 w-4" />
          Become a Host
        </Button>
      </div>
    );
  }

  const renderButtons = () => {
    switch (userRole) {
      case "guest":
        return (
          <>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/properties")}
              className={buttonClassName}
            >
              <MapPin className="h-4 w-4" />
              Browse Properties
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/guest/wishlists")}
              className={buttonClassName}
            >
              <Heart className="h-4 w-4" />
              Wishlists
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/guest/bookings")}
              className={buttonClassName}
            >
              <Calendar className="h-4 w-4" />
              My Bookings
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/guest/messages")}
              className={buttonClassName}
            >
              <MessageSquare className="h-4 w-4" />
              Messages
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/guest/preferences")}
              className={buttonClassName}
            >
              <Settings className="h-4 w-4" />
              Settings
            </Button>
          </>
        );
      case "host":
        return (
          <>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/host/properties")}
              className={buttonClassName}
            >
              <Home className="h-4 w-4" />
              My Properties
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/host/bookings")}
              className={buttonClassName}
            >
              <Calendar className="h-4 w-4" />
              Bookings
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/host/messages")}
              className={buttonClassName}
            >
              <MessageSquare className="h-4 w-4" />
              Messages
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/host/settings")}
              className={buttonClassName}
            >
              <Settings className="h-4 w-4" />
              Settings
            </Button>
          </>
        );
      case "admin":
        return (
          <>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/admin/properties")}
              className={buttonClassName}
            >
              <Home className="h-4 w-4" />
              Manage Properties
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/admin/users")}
              className={buttonClassName}
            >
              <Settings className="h-4 w-4" />
              Manage Users
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/admin/messages")}
              className={buttonClassName}
            >
              <MessageSquare className="h-4 w-4" />
              Messages
            </Button>
            <Button
              variant={buttonVariant}
              onClick={() => navigate("/admin/settings")}
              className={buttonClassName}
            >
              <Settings className="h-4 w-4" />
              System Settings
            </Button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={isMobile ? "flex flex-col space-y-2" : "flex items-center space-x-4"}>
      {renderButtons()}
    </div>
  );
};